import React, { ElementType } from "react";
import DefaultProductIcon from "./DefaultProductIcon";
import OdIcon from "./OdIcon";
import RerIcon from "./RerIcon";
import RmIcon from "./RmIcon";
import TsIcon from "./TsIcon";
import JaIcon from "./JaIcon";

const productIconMapping: Record<string, ElementType> = {
  ctm: RmIcon,
  od: OdIcon,
  rer: RerIcon,
  ts: TsIcon,
  ja: JaIcon
};

export function getProductIcon(productId: string) {
  const masterId = Object.keys(productIconMapping).find(id =>
    productId.startsWith(id)
  );
  return productIconMapping[masterId ?? ""] ?? DefaultProductIcon;
}

export function renderProductIcon(productId: string) {
  const ProductIcon = getProductIcon(productId);
  return <ProductIcon />;
}
